import { connect } from 'react-redux'
import MagicLinks from './magic-links'
import { withRouter } from 'react-router'
import { fetchMagicLinkInfo } from './redux/magic-links.actions'
import { setToken } from 'pobble-components/dist/auth-helpers'
import { constructRequest, constructRedirectLink } from './helpers'
import {
  getTypeOfError,
  getActionRedirect,
  getLink,
  isLinkResent,
  getLinkState
} from './redux/magic-links.selectors'
import screensMap from './screens-map'
import { apiClient } from 'pobble-components/dist/api'

const mapStateToProps = (state, { match }) => {
  const link = getLink(state)
  const error = getTypeOfError(state)
  const redirect = getActionRedirect(state)
  const linkResent = isLinkResent(state)
  const linkState = getLinkState(state)
  if (linkResent) return { ScreenToShow: screensMap.link_resent }

  if (link && link.validity !== 'valid')
    return { ScreenToShow: screensMap.error_expired }

  if (error) return { ScreenToShow: screensMap[error] }

  if (redirect) {
    const screen = screensMap[redirect.to]
    if (screen) return { ScreenToShow: screen, params: redirect.params }
    const redirectLink = constructRedirectLink(redirect)

    /**
     * Add signup origin query param to finish sign up
     * in order to track it with analytics
     */
    if (redirectLink === '/auth/finish-signup') {
      apiClient
        .get('v3/me', {
          params: {
            include: 'account.signup_details'
          }
        })
        .then(res => {
          if (res.data.account.signup_origin) {
            window.location.href = `/auth/finish-signup?from=${
              res.data.account.signup_origin
            }`
          } else {
            window.location.href = '/auth/finish-signup'
          }
        })
    } else {
      window.location.href = redirectLink || '/'
    }
  }

  return {
    ScreenToShow: screensMap.pending,
    initial: linkState.initial,
    action: match.params.action
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  applyLink: () => {
    return dispatch(fetchMagicLinkInfo(match.params.token))
      .then(res => {
        setToken(res.data.jwt || '')
        const action = res.data.actions[match.params.action]
        const request = constructRequest(action.do, match.params.action)
        dispatch(request()).catch(e => e)
      })
      .catch(e => e)
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MagicLinks)
)
